import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingFarmResourceRetailers, setFootprintingFarmResourceRetailersAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM, FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN, FOOTPRINTING_FARM_RESOURCE_PURCHASES, FOOTPRINTING_FARM_RESOURCE_RETAILERS } from "consts";

import { FootprintingFarmRetailerPayload } from "models";

export const useMutateFootprintingFarmResourcePurchases = (
  farmId: string,
  year: number,
  payload: FootprintingFarmRetailerPayload & { farmId: string },
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingFarmResourceRetailersAdmin : setFootprintingFarmResourceRetailers;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_RESOURCE_PURCHASES],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_FARM_RESOURCE_RETAILERS, farmId],
          [FOOTPRINTING_FARM_RESOURCE_PURCHASES, primaryDataId],
          [FOOTPRINTING_FARM, farmId, year],
          [FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN, primaryDataId],
          [FOOTPRINTING_FARM, primaryDataId, isAdmin],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
